import React from "react";
import {Link, useLocation} from "react-router-dom";
import "./AppProfile.css";
import chevron from "../../../resources/icons/chevron-left.svg";
import {useIntl} from "react-intl";
import Image from "../../../components/Image";
import externalLink from "../../../resources/icons/external-link.svg";
import {AppLocationState} from "../../../logic/APITypes";

export type AppProfileProps = {
  name: string;
  description: string;
  logo: string;
  appUrls: {name: string; url: string}[];
  groupId: string;
  groupName: string;
};
/** The profile section of an application on the details page with name, description and logo */
function AppProfile({
  name,
  description,
  logo,
  appUrls,
  groupId,
  groupName,
}: AppProfileProps) {
  const {formatMessage} = useIntl();
  const {state}: {state: null | AppLocationState} = useLocation();

  return (
    <div className="appProfile">
      <div className="appProfile__logoContainer">
        <Image
          src={logo}
          width={114}
          height={114}
          alt={formatMessage({id: "general.logo.alt"}, {name: name})}
        />
      </div>
      <div className="appProfile__info">
        <span className="appProfile__title">
          <Link to={state?.from === "home" ? "/" : "/groups/" + groupId}>
            <img
              src={chevron}
              alt={formatMessage({
                id:
                  "appProfile.img.alt.chevron." +
                  (state?.from === "home" ? "home" : "group"),
              })}
            />
          </Link>
          <div className="appProfile__names">
            <div className="appProfile__group">{groupName}</div>
            <div>{name}</div>
          </div>
        </span>
        <p className="appProfile__description">{description}</p>
      </div>

      {appUrls.length > 0 && (
        <div className="appProfile__actions">
          {appUrls.map(({name: label, url}) => (
            <a
              key={url}
              className="linkButton"
              href={url}
              target="_blank"
              rel="noreferrer"
              aria-label={formatMessage(
                {id: "general.link.ariaLabel.external"},
                {name: label},
              )}
            >
              {label}
              <img src={externalLink} alt="" width={12} height={12} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

export default AppProfile;
